import { BankAccountDetailApp } from "bankaccount/edit/app";
import BankAccountList from "bankaccount/list/app";
import { CreateBankAccountApp } from "bankaccount/new/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const bankAccountRoute: RouteObject = {
  path: "bankaccount",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: BankAccountList,
  }, {
    path: "new",
    loader: () => viewModel,
    Component: CreateBankAccountApp,
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: BankAccountDetailApp,
  }]
};